<template>

  <div id="ticketCreate">
    <div class="dialog-content">

      <div class="context">Add images to this ticket. A ticket can have up to 15 images.</div>

      <vo-image-select ref="imageSelect" :max="15 - selected.images.length"></vo-image-select>

    </div>
    <div class="dialog-footer">
      <v-btn class="button" flat color="info" :disabled="lockout.on" @click="routeRemoveQuery('dialog')">Cancel</v-btn>
      <v-btn class="button" flat color="primary" :loading="lockout.on" @click="addImages">Add Images</v-btn>
    </div>
  </div>
</template>

<script>

  import imageUploadMixin from '../mixins/imageUploadMixin.js';

  export default {
    mixins: [imageUploadMixin],
    data () {
      return {
        title: 'Add Images'
      }
    },
    props: {
    
      lockout: {

      },
    
      dialogComponent: {

      }
    
    },
    
    methods: {

      addImages () {
        if (this.lockout.on) return;
        this.lockout.on = true;

        var imagesValid = this.validateImages();

        if (!imagesValid) {
          var remove = this.images.length - 15;
          var message = 'Please remove ' + remove + ' image' + (remove === 1 ? '.' : 's.');
          Toast.show(message, 'error');
          this.lockout.on = false;
          return;
        }
        
        // UPLOAD IMAGES IF NECESSARY
        var functions = [];
        var d = new Date();

        // IMAGES //
        for (var i = 0; i < this.images.length; ++i) {

          // CONVERT URI TO FORMDATA BLOB
          var blob = this.dataURItoBlob(this.images[i].uri);
          var fd = new FormData(document.forms[0]);
          var filename = d.getTime() + '_' + i + '_ticket';
          fd.append('canvasImage', blob, filename);
          fd.append('width', this.images[i].w);
          fd.append('height', this.images[i].h);

          // APPEND PROMISE //
          functions.push(this.$store.dispatch('addTicketImage', {
            ticket: this.selected._id, 
            image: fd
          }));
        }

        Promise.all(functions)
        .then(images => {

          // This is to store that we are waiting for this many images to upload, spinners will show in the ticket details 
          var pendingImages = 0;

          // If there are already pending images, add them to the queue 
          if (this.selected.pendingImages) pendingImages = this.selected.pendingImages;
          
          // If there aren't pending images, but there are images, account for them
          else if (this.selected.images) pendingImages += this.selected.images.length;

          // Add the new images
          pendingImages += images.length;

          this.$store.commit('storeTickets', [{
            _id: this.selected._id,
            pendingImages: pendingImages
          }]);

          this.routeRemoveQuery('dialog');
          this.lockout.on = false;

          Toast.show('Images added.', 'success');
        })
        .catch(e => {
          console.log(e);
          this.lockout.on = false;
          Toast.showError(e);
        })
      },

      validateImages () {
        return (this.images.length <= 15);
      }

    },

    computed: {
      
      images () {
        return this.$refs.imageSelect.images;
      },

      selected () {
        return this.$store.getters.ticket(this.app.pages.tickets.selected);
      }

    },

    created () {
      this.$emit('title', this.title);
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #ticketCreate {
    position: relative;

    .dialog-content {
      padding: 16px;
      min-height: 500px;
    }

    .property-required {
      pointer-events: none;
      opacity: .24;

      &.active {
        opacity: 1;
        pointer-events: auto;
      }
    }

    .consent-section {
      @include fontPrimary400();

      padding: 24px 16px 0 40px;
      border-top: $borderBlack12;
      color: $black54;

      .consent-context {
        font-size: 14px;
      }

      .checkbox {
        width: 105px;
        margin: 16px auto;
      }
    }

    @media screen and (max-width: 700px) {
    
      .dialog-content {
        min-height: 0px;
      }
    
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/TicketAddImages.vue